import request from '../index'

/**
 * 获取服务器时间
 * @param {*}
 * @returns
 */
export function serverTime() {
    return request({
        url: '/common/serverTime',
        method: 'get'
    })
}

/**
 * 用户反馈
 * @param {*} data
 * @returns
 */
export function feedback(data) {
    return request({
        url: '/box/feedback/create',
        method: 'post',
        data
    })
}

/**
 * 获取客户端IP
 * @returns
 */
export function getClientIp() {
    return request({
        url: '/common/clientIp',
        method: 'get'
    })
}

/**
 * 获取实名配置信息
 * @returns
 */
export function getAuthConfig(query) {
    return request({
        url: '/switch/info',
        method: 'get',
        params: query
    })
}

/**
 * 获取配置的客服链接--字典接口
 * @returns
 */
export function getDictConfig(query) {
    return request({
        url: '/switch/dictList',
        method: 'get',
        params: query
    })
}

/**
 * 获取邮箱验证码
 * @param {*} query
 * @returns
 */
export function getEmailCode(query) {
    return request({
        url: '/box/steam/emailCode',
        method: 'get',
        params: query,
        'axios-retry': {
            retries: 0
        }
    })
}

/**
 * 检查客户端版本更新
 * @param {*} query
 * @returns
 */
export function checkClient(query) {
    return request({
        url: '/box/versionInfo',
        method: 'get',
        params: query,
        'axios-retry': {
            retries: 0
        }
    })
}

/**
 * 启动迅游加速器token获取
 * @param {*} query
 * @returns
 */
export function getXunYouToken() {
    return request({
        url: '/box/xunyou/token',
        method: 'get'
    })
}

/**
 * 获取游戏详情--对应到迅游的游戏信息
 * @param {*} query
 * @returns
 */
export function getXunYouGameInfo(query) {
    return request({
        url: '/game/xunyougame/info',
        method: 'get',
        params: query
    })
}

/**
 * 搜索游戏反馈
 * @param {*} data
 * @returns
 */
export function searchGameFeedback(data) {
    return request({
        url: '/box/feedback/gameFeedback',
        method: 'post',
        data
    })
}

/**
 * 获取广告配置
 * @param {*} params
 * @returns
 */
export function getAdConfigs(params) {
    return request({
        url: '/game/GGameAd/list',
        method: 'get',
        params
    })
}

/**
 * 根据渠道获取下载地址
 * @param {*} params
 * @returns
 */
export function getBoxDlByChannel(params) {
    return request({
        url: '/box/BoxChannelPackage/detail',
        method: 'get',
        params
    })
}

export function getQuestionCateList(params) {
    return request({
        url: '/question/cate/list',
        method: 'get',
        params
    })
}

/**
 * 问题帮助 问题列表
 * @params {*}
 * @returns
 */
export function getQuestionList(params) {
    return request({
        url: '/question/list',
        method: 'get',
        params
    })
}
